let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1adz7")).then(() => parcelRequire('4IcCi'));